export default "__VITE_ASSET__CexfTkYA__"